import { render, staticRenderFns } from "./prospect-detail.vue?vue&type=template&id=64b0ccf0"
import script from "./prospect-detail.vue?vue&type=script&lang=js"
export * from "./prospect-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports